'use client';

import { FC } from 'react';
import Button from '~/components/button';
import AppRoute from '~/enums/app-route';

import styles from './styles.module.css';

interface Props {
  isBlogPage: boolean;
  title: string;
  onClick: () => Promise<void>;
  loading: boolean;
}

const ArticleListButton: FC<Props> = ({ isBlogPage, title, onClick, loading = false }) => {
  if (!isBlogPage) return <Button className={styles.button} href={`/${AppRoute.BLOG}`} title={title} />;

  return (
    <Button loading={loading} className={styles.button} onClick={onClick} title={title} linkProps={{ scroll: false }} />
  );
};

export default ArticleListButton;
